<template>
  <qx-card-form title="成本信息">
    <qx-custom-form
      :noSubBtn="true"
      ref="baseForm"
      :formData="baseForm"
      labelWidth="120px"
    >
      <span slot="oilCostPerUnit" class="unit">升/百公里</span>
      <span class="tip" slot="oilCostPerTip">
        <el-tooltip content="本线路开单时将按这个标准给司机分配油量">
          <i class="el-icon-question error"></i>
        </el-tooltip>
      </span>
      <span slot="pontagePerUnit" class="unit">元/公里</span>
      <span class="tip" slot="pontagePerTip">
        <el-tooltip content="本线路开单时将这个标准计提路桥费">
          <i class="el-icon-question error"></i>
        </el-tooltip>
      </span>
      <span slot="emptyOilCostPerUnit" class="unit">升/百公里</span>
      <span class="tip" slot="emptyOilCostPerTip">
        <el-tooltip content="本线路开单时将这个标准给司机分配空载里程的油量">
          <i class="el-icon-question error"></i>
        </el-tooltip>
      </span>
    </qx-custom-form>
  </qx-card-form>
</template>

<script>
export default {
  data () {
    return {
      baseForm: {
        inline: true,
        form: [
          {
            label: '载重油耗',
            value: 'oilCostPer',
            type: 'input',
            width: '240px',
          },
          {
            label: '单公里路桥',
            value: 'pontagePer',
            type: 'input',
            width: '240px',
          },
          {
            label: '空载油耗',
            value: 'emptyOilCostPer',
            type: 'input',
            width: '240px',
          },
        ],
        rules: {
          oilCostPer: [ // 载重油耗
            { required: true, message: '请输入载重油耗', trigger: 'blur' },
          ],
          pontagePer: [ // 单公里路桥
            { required: true, message: '请输入单公里路桥', trigger: 'blur' },
          ],
          emptyOilCostPer: [ // 空载油耗
            { required: true, message: '请输入空载油耗', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {
    async cacheData () {
      const formData = await this.$refs.baseForm.getVal();
      return formData;
    },

    async sub () {
      const formData = await this.$refs.baseForm.sub();
      return formData;
    },
    init (data = {}) {
      const res = {
        oilCostPer: data.oilCostPer,
        pontagePer: data.pontagePer,
        emptyOilCostPer: data.emptyOilCostPer,
      };
      this.$refs.baseForm.setVal('form', res);
    },
  },
};
</script>

<style scoped lang="scss">
.tip{
  margin-left: 16px;
  color: #999;
  span{
    color: #666;
    margin-right: 8px;
  }
}
</style>
